import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";

export class BasicView extends View {

    constructor(protected override readonly services: GameServices, specKey: string) {
        super(services);

        const {factory, resources} = this.services;

        const spec = resources.getSpec(specKey);
        factory.applySpec(this, spec);

        let sprite;

        for (const childName of Object.keys(spec.slices)) {
            sprite = factory.createSprite(spec.slices[childName], this);

            if (spec.slices[childName].blendMode !== undefined) {
                sprite.blendMode = spec.slices[childName].blendMode;
            }
        }
    }
}